import type { IsoTime } from '../../types/iso-date';

export function isIsoTime(str: string): str is IsoTime {
  // Strict format: THH:mm:ss(.fraction[1-6])? with no timezone
  // - Hours: 00-23, Minutes: 00-59, Seconds: 00-59
  // - Fractional seconds: 1-6 digits allowed
  const re = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)(?:\.(\d{1,6}))?$/;
  return re.test(str);
}
